import { AppLauncher } from '@capacitor/app-launcher'
import { AnalyticsBrowser } from '@customerio/cdp-analytics-browser'
import { PushNotifications } from '@capacitor/push-notifications'
import { Capacitor } from '@capacitor/core'
import eventBus from '@/service/EventBus.js'
import { getCurrentUser } from '@/service/UserService.js'
import api from '@/service/Api.js'

const cio = AnalyticsBrowser.load({ writeKey: process.env.CIO_WRITE_KEY })
eventBus.spa.on('user-auth', userInit)
eventBus.spa.on('device-token', handleDeviceToken)

let lastRegisteredDevice = null
let pushPermissionRequested = false

async function userInit() {
    const { userId, email, deviceToken } = await getCurrentUser()
    await cio.identify(userId, { email })
    await cio.track('User Authenticated')
    
    if (!Capacitor.isNativePlatform()) return

    if (!pushPermissionRequested) {
        pushPermissionRequested = true
        await requestPermissions()
    }

    await registerNativeDevice({ userId, deviceToken })
}

async function handleDeviceToken(deviceToken) {
    if (!Capacitor.isNativePlatform()) return
    const { userId } = await getCurrentUser()
    await registerNativeDevice({ userId, deviceToken })
}

async function registerNativeDevice({ userId, deviceToken }) {
    if (!userId || !deviceToken) return
    const platform = Capacitor.getPlatform()
    const registrationKey = `${userId}:${platform}:${deviceToken}`
    if (registrationKey === lastRegisteredDevice) return
    await api.registerDevice({ deviceToken, platform })
    lastRegisteredDevice = registrationKey
}

function init(router) {
    if (!Capacitor.isNativePlatform()) return

    PushNotifications.addListener('registration', async token => {
        console.log('PushNotifications registration listener')
        eventBus.spa.emit('device-token', token.value)
    }).then(console.log)

    PushNotifications.addListener('registrationError', err => {
        console.log('PushNotifications registrationError listener')
        console.error('Registration error:', err)
        console.error('Registration error:', err.error)
    }).then(console.log)

    PushNotifications.addListener('pushNotificationReceived', async notification => {
        console.log('PushNotifications pushNotificationReceived listener')
        await cio.track('Foreground Push Received', { notification })
    }).then(console.log)

    PushNotifications.addListener('pushNotificationActionPerformed', async action => {
        console.log('PushNotifications pushNotificationActionPerformed listener')
        await cio.track('Background Push Touched', { action })
        const link = action.notification.data?.link
        if (link) {
            if (link.startsWith('/')) {
                console.log(`navigating to deep link: ${link}`)
                await router.push(link)
                return
            }
            console.log(`navigating to external link: ${link}`)
            await AppLauncher.openUrl({ url: link })
            return
        }
        console.log(`no deepLink`)
    }).then(console.log)
}

async function requestPermissions() {
    console.log('requestPermissions')
    if (!Capacitor.isNativePlatform()) return

    const { receive } = await PushNotifications.requestPermissions()
    console.log('handlePermissionGranted: ', receive)
    if (receive === 'granted') await PushNotifications.register()
}

async function addTags(tags) {
    const { userId } = await getCurrentUser()
    await cio.identify(userId, tags)
}

async function track(eventName) {
    await cio.track(eventName)
}

export default {
    init,
    addTags,
    track,
    requestPermissions,
}
